// extracted by mini-css-extract-plugin
export default {"is-favorite":"FavoriteToggle_is-favorite__PZxZV"};